import 'moment-timezone';

import { Injectable } from '@angular/core';
import {
    getActiveEntity, getEntity, selectActiveEntity, setActiveId, setActiveIds, setEntities
} from '@ngneat/elf-entities';
import { updateRequestCache, updateRequestStatus } from '@ngneat/elf-requests';
import { CacheService } from '@shared/services';

import { BaseRepository } from '../base.repository';
import { store } from './session.store';

@Injectable({ providedIn: 'root' })
export class SessionRepository extends BaseRepository {
	public active$ = store.pipe(selectActiveEntity());
	public active = store.query(getActiveEntity());

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private readonly cache: CacheService) {
		super();
	}
	get = (id, key) => store.query(getEntity(id))?.[key];
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - addSession
	 **-------------------------------------------------------------------------------------
	 */
	public addSession(session): void {
		store.update(
			setActiveId(session.company_id),
			setActiveIds([session.company_id]),
			setEntities([session]),
			updateRequestCache(`session-${session.company_id}`, { value: 'full' }),
			updateRequestStatus('session', 'success')
		);
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - store
	 **-------------------------------------------------------------------------------------
	 */
	get store() {
		return store;
	}
}
